import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sms-services.help.sms-credit', {
        url: '/sms-credit',
        component: 'companySmsServicesHelpSmsCredit',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sms-services/help/sms-credit/sms-credit.state.js